import { render, staticRenderFns } from "./IgnoreFraudScore.vue?vue&type=template&id=2f10d28f&"
import script from "./IgnoreFraudScore.vue?vue&type=script&lang=js&"
export * from "./IgnoreFraudScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports